/**
 * Step Mapping Utilities
 * Pure functions for step relationships and navigation
 */

import { STEP_NAMES } from '../constants/steps';

/**
 * Account step names for type checking
 */
const ACCOUNT_STEPS = [
  STEP_NAMES.CREATE_ACCOUNT,
  STEP_NAMES.UPDATE_ACCOUNT,
  STEP_NAMES.ENABLE_ACCOUNT,
  STEP_NAMES.DISABLE_ACCOUNT,
  STEP_NAMES.REMOVE_ACCOUNT,
] as const;

/**
 * Map each step to its immediate next step
 */
const NEXT_STEP_MAP: Record<string, string> = {
  [STEP_NAMES.CONNECTION]: STEP_NAMES.CREATE_ACCOUNT,
  [STEP_NAMES.CREATE_ACCOUNT]: STEP_NAMES.UPDATE_ACCOUNT,
  [STEP_NAMES.UPDATE_ACCOUNT]: STEP_NAMES.ENABLE_ACCOUNT,
  [STEP_NAMES.ENABLE_ACCOUNT]: STEP_NAMES.DISABLE_ACCOUNT,
  [STEP_NAMES.DISABLE_ACCOUNT]: STEP_NAMES.REMOVE_ACCOUNT,
  [STEP_NAMES.REMOVE_ACCOUNT]: STEP_NAMES.ADD_ACCESS,
};

/**
 * Get the immediate next step for a given step
 */
export const getNextStep = (stepName: string): string | null =>
  NEXT_STEP_MAP[stepName] ?? null;

/**
 * Check if step is an account step
 */
export const isAccountStep = (stepName: string): boolean =>
  ACCOUNT_STEPS.includes(stepName as (typeof ACCOUNT_STEPS)[number]);

/**
 * Check if step supports previous edit functionality
 */
export const isEditableStep = (stepName: string): boolean =>
  stepName === STEP_NAMES.CONNECTION || isAccountStep(stepName);
